import fetchRetentionPayments from '../../../Services/fetchRetentionPayments'

export default () => (dispatch) => {

  dispatch(fetchRetentionPayments())

}
